import { render, staticRenderFns } from "./my_info.vue?vue&type=template&id=aaf99038&scoped=true"
import script from "./my_info.vue?vue&type=script&lang=js"
export * from "./my_info.vue?vue&type=script&lang=js"
import style0 from "./my_info.vue?vue&type=style&index=0&id=aaf99038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf99038",
  null
  
)

export default component.exports